import { ScheduledMeetingResourceTypeMappings } from '@aa/nest/resource';
import {
  MEETING_STATUS,
  meetingStatusLabels,
  meetingStatusColors,
} from '@aa/nest/resource/objects';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { computeTextColorForBackground, formatDateTime } from '@aa/ts/common';
import {
  DataTableColumnConfig,
  DataTableRowAction,
} from '../../components/data-table/data-table.component';
import {
  BaseResourceListViewComponent,
  baseResourceListViewImports,
} from '../base-resource-list-view/base-resource-list-view.component';
import { scheduledMeetingActions } from '../../state/scheduled-meeting/scheduled-meeting.actions';
import { selectScheduledMeetingState } from '../../state/scheduled-meeting/scheduled-meeting.reducer';

@Component({
  selector: 'aa-scheduled-meetings-list-view',
  standalone: true,
  imports: [...baseResourceListViewImports],
  templateUrl:
    '../../../../../core/src/lib/views/base-resource-list-view/base-resource-list-view.component.html',
  styleUrl:
    '../../../../../core/src/lib/views/base-resource-list-view/base-resource-list-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduledMeetingsListViewComponent extends BaseResourceListViewComponent<ScheduledMeetingResourceTypeMappings> {
  title = 'Scheduled Meetings';
  columns = [
    // {
    //   key: 'id',
    //   label: 'ID',
    //   minWidth: '3rem',
    // },
    {
      key: 'customer',
      label: 'Customer',
      accessor: (row) =>
        `${row.customerProfile!.firstName} ${row.customerProfile!.lastName}`,
    },
    {
      key: 'meetingType',
      label: 'Meeting Type',
      accessor: (row) => `${row.meetingType!.label}`,
    },
    {
      key: 'startAt',
      label: 'Start at',
      accessor: (row) => formatDateTime(row.startAt),
    },
    {
      key: 'endAt',
      label: 'End at',
      accessor: (row) => formatDateTime(row.endAt),
    },
    // {
    //   key: 'gateway',
    //   label: 'Gateway',
    // },
    {
      key: 'status',
      label: 'Status',
      accessor: (row) => meetingStatusLabels[row.status as MEETING_STATUS],
      getBackgroundColor: (row) =>
        meetingStatusColors[row.status as MEETING_STATUS],
      getTextColor: (row) =>
        computeTextColorForBackground(
          meetingStatusColors[row.status as MEETING_STATUS],
        ),
    },
    {
      key: 'createdAt',
      label: 'Created At',
      accessor: (row) => formatDateTime(row.createdAt),
      minWidth: '15rem',
    },
    {
      key: 'updatedAt',
      label: 'Updated At',
      accessor: (row) => formatDateTime(row.updatedAt),
      minWidth: '15rem',
    },
  ] as DataTableColumnConfig<
    ScheduledMeetingResourceTypeMappings['resourceWithRelationsT']
  >[];

  override hideAdd = true;

  stateSelector = selectScheduledMeetingState;
  loadAction = scheduledMeetingActions.loadItems({
    query: {
      pageSize: this.initialPageSize,
      include: {
        customerProfile: true,
        meetingType: true,
      },
      orderBy: {
        createdAt: 'desc',
      },
    },
  });
  actions = scheduledMeetingActions;

  override rowActions: DataTableRowAction<
    ScheduledMeetingResourceTypeMappings['resourceWithRelationsT']
  >[] = [
    {
      key: 'approve',
      label: 'Approve',
      icon: 'check_circle',
      hide: (row) => row.status != MEETING_STATUS.REQUESTED,
      onClick: (item) => this.approveMeeting(item),
    },
    {
      key: 'reject',
      label: 'Reject',
      icon: 'cancel',
      hide: (row) => row.status != MEETING_STATUS.REQUESTED,
      onClick: (item) => this.rejectMeeting(item),
    },
    {
      key: 'cancel',
      label: 'Cancel & Refund',
      icon: 'replay',
      hide: (row) => row.status != MEETING_STATUS.APPROVED,
      onClick: (item) => this.cancelMeeting(item),
    },
    // {
    //   key: 'delete',
    //   label: 'Delete',
    //   icon: 'delete',
    //   onClick: (item) => this.promptDeleteItem(item),
    // },
  ];

  createFormModalTypeGetter = () => undefined;
  updateFormModalTypeGetter = () => undefined;

  approveMeeting(
    meeting: ScheduledMeetingResourceTypeMappings['resourceWithRelationsT'],
  ) {
    this.store.dispatch(
      scheduledMeetingActions.approve({
        id: meeting.id,
      }),
    );
  }

  rejectMeeting(
    meeting: ScheduledMeetingResourceTypeMappings['resourceWithRelationsT'],
  ) {
    this.store.dispatch(
      scheduledMeetingActions.reject({
        id: meeting.id,
      }),
    );
  }

  cancelMeeting(
    meeting: ScheduledMeetingResourceTypeMappings['resourceWithRelationsT'],
  ) {
    this.store.dispatch(
      scheduledMeetingActions.cancel({
        id: meeting.id,
      }),
    );
  }
}
